import { ssoApi } from '@/services/instance/api/ssoApi';
import { optionsService } from '@/services/instance/optionsService';
import { Sso } from '@/services/sso';

export const sso = new Sso({
    ssoApi,
    optionsService,
});
